module.exports = __webpack_public_path__ + "static/media/play_store.9b3bb18d.png";